import React from "react";

import "./styles.scss";

interface AutocompleteSuggestionsProps {
  suggestions: string[];
  onSelectSuggestion: (suggestion: string) => void;
}

export const AutocompleteSuggestions = ({
  suggestions,
  onSelectSuggestion,
}: AutocompleteSuggestionsProps) => {
  if (suggestions.length === 0) return null;

  return (
    <div className="autocomplete-suggestions">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          className="autocomplete-suggestion btn btn-border"
          onClick={() => onSelectSuggestion(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};
